import { z } from "zod";
import { uuidSchema } from "./common";

export const appointmentTypeSchema = z.enum([
  "INITIAL_MTM",
  "FOLLOW_UP",
  "POST_DISCHARGE_REVIEW",
  "POLYPHARMACY_REVIEW",
  "CHRONIC_MEDICATION_MANAGEMENT",
  "GENERAL_CONSULTATION",
]);

export const appointmentChannelSchema = z.enum(["VIDEO", "PHONE", "IN_PERSON", "ASYNC_REVIEW"]);

export const bookAppointmentSchema = z.object({
  serviceId: uuidSchema,
  pharmacistId: uuidSchema.optional(),
  channel: appointmentChannelSchema.default("VIDEO"),
  // Accepts both a full ISO datetime and the value shape produced by an
  // <input type="datetime-local"> ("YYYY-MM-DDTHH:mm"); the server normalizes to ISO.
  scheduledAt: z
    .string()
    .min(1, "Choose a valid appointment time")
    .refine((v) => !Number.isNaN(new Date(v).getTime()), "Choose a valid appointment time"),
  reasonForVisit: z.string().trim().max(500).optional(),
});

export type BookAppointmentInput = z.infer<typeof bookAppointmentSchema>;

export const cancelAppointmentSchema = z.object({
  reason: z.string().trim().min(1, "A cancellation reason is required").max(300),
});
